import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@/components/button";
import { ActionDoneIndicator } from "../action-done-indicator";
import { useComposerStore } from "@/stores/composers";
import { useTaskDetailStore } from "@/stores/task-detail";
import { useActionCompletionStore } from "@/stores/action-completion";
import { useTaskActions } from "@/components/task-actions-provider";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** A single form action row — opens the form composer at the suggested form; marks done only after the form is submitted. */
export function FormAction(_ref) {
  var _template$display_nam2;
  var action = _ref.action,
    template = _ref.template,
    patientUid = _ref.patientUid,
    reminderId = _ref.reminderId,
    isDone = _ref.isDone,
    onDelete = _ref.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var openComposer = useComposerStore(function (s) {
    return s.open;
  });
  var minimizeTaskDetail = useTaskDetailStore(function (s) {
    return s.minimize;
  });
  var setPendingCompletion = useActionCompletionStore(function (s) {
    return s.setPending;
  });
  var _useTaskActions = useTaskActions(),
    onCompleteForm = _useTaskActions.onCompleteForm;
  var payload = action.payload;
  var handleOpen = function handleOpen() {
    var _template$display_nam;
    trackEvent(ANALYTICS_EVENTS.FORM_ACTION_OPEN, {
      actionId: action.id
    });
    if (onCompleteForm) {
      if (patientUid != null) {
        setPendingCompletion("form", {
          patientUid: patientUid,
          reminderId: reminderId,
          actionId: action.id
        });
      }
      onCompleteForm(payload.id);
      return;
    }
    minimizeTaskDetail();
    openComposer({
      id: "form-action-".concat(action.id),
      type: "form",
      title: (_template$display_nam = template === null || template === void 0 ? void 0 : template.display_name) !== null && _template$display_nam !== void 0 ? _template$display_nam : t("label.open_form", {
        defaultValue: "Open form"
      }),
      initialTemplateId: payload.id,
      lockTemplate: true,
      actionMeta: {
        reminderId: reminderId,
        actionId: action.id
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 border px-4 py-3 flex items-center gap-3 ".concat(isDone ? "bg-sds-base-secondary border-transparent" : "bg-sds-base-default border-sds-base-default")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5 flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong truncate ".concat(isDone ? "line-through text-sds-base-secondary" : "text-sds-base-default")
  }, (_template$display_nam2 = template === null || template === void 0 ? void 0 : template.display_name) !== null && _template$display_nam2 !== void 0 ? _template$display_nam2 : t("label.unknown_form", {
    defaultValue: "Form"
  })), (template === null || template === void 0 ? void 0 : template.use_case) && /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, template.use_case)), isDone ? /*#__PURE__*/React.createElement(ActionDoneIndicator, {
    label: t("status.completed", {
      defaultValue: "Completed"
    })
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "form-action-open-".concat(action.id),
    intent: "brand",
    variant: "secondary",
    size: "sm",
    onClick: handleOpen
  }, t("button.open_and_complete", {
    defaultValue: "Open & complete"
  })), /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "form-action-delete-".concat(action.id),
    "aria-label": t("button.delete", {
      defaultValue: "Delete"
    }),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.FORM_ACTION_DELETE, {
        actionId: action.id
      });
      onDelete(action.id);
    },
    className: "w-7 h-7 flex items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-urgent-tertiary hover:text-sds-urgent-default transition-colors flex-shrink-0"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTrash,
    className: "w-3.5 h-3.5"
  }))));
}